
import { OrderParty } from "@/models/api/orders/get";
import Vue from "vue";
import { Prop, Component, Ref } from "vue-property-decorator";
import { formatPhoneNumber } from "../../utils";
import AddressVerificationStatus from "../../components/order/AddressVerificationStatus.vue";
import AddressWidgetGeocodeModal from "@/components/widgets/Modals/AddressWidgetGeocodeModal.vue";
import permissions from "@/security/permissions";
//this is passed from the 'party' object from OrderParty
const defaultContact: OrderParty = {
  address: {
    city: "",
    state: "",
    streetLine1: "",
    streetLine2: "",
    zip: ""
  },
  id: "",
  location: null,
  name: "",
  emailAddress: "",
  phoneType: "",
  phoneNumber: "",
  primaryPhone: "",
  secondaryPhone: null,
  standardizedAddress: null,
  agentId: null,
  displayId: null
};

@Component({
  components: {
    AddressWidgetGeocodeModal,
    AddressVerificationStatus,
  }
})
export default class Address extends Vue {
  @Prop({default: "name"})
  type: string;

  @Prop({ default: false })
  displayId: boolean;

  @Prop({ default: defaultContact })
  contact: OrderParty;

  @Prop({ default: false })
  showStandardized: boolean;

  @Prop({ default: null })
  addressVerificationStatusId: number;

  @Prop({ default: 0 })
  deliveryForId: number | null;

  @Prop({ default: false})
  showGeocodeButton: boolean;

  @Ref() readonly geoCodeSelector!: any;

  get isAgentOrder() : boolean {
    return this.deliveryForId !== null && this.deliveryForId > 0;
  }

  get formatPhoneNumber(): string {
    return formatPhoneNumber(this.contact.primaryPhone);
  }

  get formattedPhoneNumber(): string {
    return formatPhoneNumber(this.contact.phoneNumber);
  }

  get refGeocodeModal(): string {
    return "geoCodeSelector";
  }

  getFormattedCoordinates(coordinate){
    return parseFloat(coordinate).toFixed(5);
  }

  showGeocodeModal() {
    this.geoCodeSelector.show();
  }

  async copy(x) {
    await navigator.clipboard.writeText(x).then(() => {
      this.makeToast();
    });
  }

  makeToast(append = false) {
    this.$bvToast.toast(`${this.formatPhoneNumber} copied to clipboard!`, {
      autoHideDelay: 500,
      title: "Copied",
      toaster: "b-toaster-bottom-left",
      appendToast: append
    });
  }
}
